import { render, staticRenderFns } from "./QuickOrder.vue?vue&type=template&id=b5250726&scoped=true&"
import script from "./QuickOrder.vue?vue&type=script&lang=js&"
export * from "./QuickOrder.vue?vue&type=script&lang=js&"
import style0 from "./QuickOrder.vue?vue&type=style&index=0&id=b5250726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5250726",
  null
  
)

export default component.exports